type DeltaOp = { insert?: unknown; attributes?: { link?: unknown } };

export type LinkRun = { index: number; length: number; href: string };

/**
 * The link the character before `index` belongs to, as one run even when
 * other formats (a colour, say) split it into several ops.
 */
const findLinkRun = (ops: DeltaOp[], index: number): LinkRun | null => {
  const runs: LinkRun[] = [];
  let position = 0;

  for (const op of ops) {
    const length = typeof op.insert === "string" ? op.insert.length : 1;
    const href = op.attributes?.link;

    if (typeof href === "string") {
      const lastRun = runs[runs.length - 1];
      if (
        lastRun?.href === href &&
        lastRun.index + lastRun.length === position
      ) {
        lastRun.length += length;
      } else {
        runs.push({ index: position, length, href });
      }
    }
    position += length;
  }

  return (
    runs.find((run) => run.index < index && index <= run.index + run.length) ??
    null
  );
};

export default findLinkRun;
